import React from 'react';

import {Link} from '../../../../lib/routes';

import {linkClass} from './link-style';

type Props = {
	args: string[];
	name: string;
};

/** типы существ, у которых есть своя статья правил: id статьи совпадает с id типа */
const CREATURE_TYPES = new Set([
	'aberration',
	'beast',
	'celestial',
	'construct',
	'dragon',
	'elemental',
	'fey',
	'fiend',
	'giant',
	'humanoid',
	'monstrosity',
	'ooze',
	'plant',
	'undead',
]);

// {@creatureType type, Термин на русском}
export const CreatureTypePlugin: React.FC<Props> = ({args}) => {
	const [id, title] = args;
	return (
		<Link
			route={'rule'}
			params={{id: CREATURE_TYPES.has(id) ? id : 'creature-type'}}
			title={title}
			className={linkClass('creatureType')}
		>
			{title}
		</Link>
	);
};
